import { render } from "./userInfo.vue?vue&type=template&id=35c488df&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=35c488df&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35c488df"

export default script